import { HttpClient, HttpHeaders } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { lastValueFrom } from 'rxjs';
import { environment } from '../../../environments/environment';
import { RedefinirSenhaModel } from '../models/redefinir-senha.model';

@Injectable({
  providedIn: 'root',
})
export class RecuperarSenhaService {
  httpClient = inject(HttpClient);
  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
    }),
    withCredentials: true,
  };
  constructor() {}

  async recuperarToken(dadosContato: string) {
    return await lastValueFrom(
      this.httpClient.get(
        `${environment.apiPessoa}/recuperarSenha?dadosContato=${dadosContato}`,
        this.httpOptions
      )
    );
  }

  async alterarSenha(redefinirSenha: RedefinirSenhaModel) {
    return await lastValueFrom(
      this.httpClient.post<boolean>(
        `${environment.apiPessoa}/redefinirSenha`,
        JSON.stringify(redefinirSenha),
        this.httpOptions
      )
    );
  }
}
